function filterjs(Vue) {
  if (filterjs.installed) {
    return
  }
  // 时间格式化全局方法
  Vue.filter('dateFormat', (dateObj, format) => {
    if (!dateObj) {
      return ''
    }

    if (!(dateObj instanceof Date)) {
      dateObj = new Date(dateObj * 1)
    }
    let date = {
      'M+': dateObj.getMonth() + 1,
      'd+': dateObj.getDate(),
      'h+': dateObj.getHours(),
      'm+': dateObj.getMinutes(),
      's+': dateObj.getSeconds(),
      'q+': Math.floor((dateObj.getMonth() + 3) / 3),
      'S+': dateObj.getMilliseconds()
    }
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in date) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length === 1
          ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
      }
    }
    return format
  })

  Vue.filter('nulls', (val) => {
    return val || '-'
  })
  Vue.filter('age', (val) => {
    if(!val)return
    let a=new Date().getFullYear()
    let b=val.substring(6,10)
    // console.log(b,a-b)
    return a-b
  })
}

export default filterjs



// WEBPACK FOOTER //
// ./src/assets/globalJS/filter.js